import axios from 'ts-axios-new';
import {formatUpstreamError} from '../libs/errorDisplay';

export type UpstreamEnvelope = {
    code?: number;
    message?: string;
    data?: any;
    error?: any;
    meta?: any;
};

export type ProxyResult = {
    upstream: UpstreamEnvelope;
    elapsed_ms?: number;
    api_base_url?: string;
};

function unwrapCms(res: any): ProxyResult {
    const payload = res?.data?.data || {};
    return {
        upstream: payload.upstream || {},
        elapsed_ms: payload.elapsed_ms,
        api_base_url: payload.api_base_url || '',
    };
}

function assertUpstreamOk(result: ProxyResult, fallback: string) {
    const upstream = result.upstream || {};
    if (upstream.code !== undefined && Number(upstream.code) !== 0) {
        throw new Error(formatUpstreamError(upstream, fallback));
    }
    return result;
}

export async function admobGet(
    path: string,
    query: Record<string, string | number | undefined> = {},
): Promise<ProxyResult> {
    const params: Record<string, string> = {path};
    for (const [key, value] of Object.entries(query)) {
        if (value === undefined || value === null || value === '') {
            continue;
        }
        params[key] = String(value);
    }
    const res = await axios.get('/cms/v1/admob/proxy', {params});
    if (Number(res?.data?.status?.code ?? 0) !== 0) {
        const upstream = res?.data?.data?.upstream;
        if (upstream && typeof upstream === 'object') {
            throw new Error(formatUpstreamError(upstream, res?.data?.status?.message || 'CMS 请求失败'));
        }
        throw new Error(res?.data?.status?.message || 'CMS 请求失败');
    }
    return assertUpstreamOk(unwrapCms(res), '上游 GET 失败');
}

export async function admobDryRun(
    method: 'POST' | 'PATCH',
    path: string,
    change: Record<string, any>,
    extras: Record<string, any> = {},
): Promise<ProxyResult> {
    const body = {mode: 'dry_run', change, ...extras};
    const res =
        method === 'POST'
            ? await axios.post('/cms/v1/admob/proxy', body, {params: {path}})
            : await axios.patch('/cms/v1/admob/proxy', body, {params: {path}});
    if (Number(res?.data?.status?.code ?? 0) !== 0) {
        const upstream = res?.data?.data?.upstream;
        if (upstream && typeof upstream === 'object') {
            throw new Error(formatUpstreamError(upstream, res?.data?.status?.message || 'CMS 请求失败'));
        }
        throw new Error(res?.data?.status?.message || 'CMS 请求失败');
    }
    return assertUpstreamOk(unwrapCms(res), '上游 dry-run 失败');
}

export async function admobApply(
    method: 'POST' | 'PATCH',
    path: string,
    dryRunId: string,
    planHash: string,
): Promise<ProxyResult> {
    const body = {
        mode: 'apply',
        dry_run_id: dryRunId,
        plan_hash: planHash,
    };
    const res =
        method === 'POST'
            ? await axios.post('/cms/v1/admob/proxy', body, {params: {path}})
            : await axios.patch('/cms/v1/admob/proxy', body, {params: {path}});
    if (Number(res?.data?.status?.code ?? 0) !== 0) {
        const upstream = res?.data?.data?.upstream;
        if (upstream && typeof upstream === 'object') {
            throw new Error(formatUpstreamError(upstream, res?.data?.status?.message || 'CMS 请求失败'));
        }
        throw new Error(res?.data?.status?.message || 'CMS 请求失败');
    }
    return assertUpstreamOk(unwrapCms(res), '上游 apply 失败');
}

export async function admobReport(
    path: string,
    reportSpec: Record<string, any>,
): Promise<ProxyResult> {
    const res = await axios.post(
        '/cms/v1/admob/proxy',
        {reportSpec},
        {params: {path}},
    );
    if (Number(res?.data?.status?.code ?? 0) !== 0) {
        const upstream = res?.data?.data?.upstream;
        if (upstream && typeof upstream === 'object') {
            throw new Error(formatUpstreamError(upstream, res?.data?.status?.message || 'CMS 请求失败'));
        }
        throw new Error(res?.data?.status?.message || 'CMS 请求失败');
    }
    return assertUpstreamOk(unwrapCms(res), '上游报表失败');
}
